
export function GetCookie(elementName: string = "csrfmiddlewaretoken") {
    const csrfToken = document.getElementsByName(elementName)[0];
    if (csrfToken != undefined) {
      return csrfToken.getAttribute("value");
    }
    throw new Error("CSRF Token not found");
  }
  